<!--
 * @Author: lan.h
 * @Date: 2021-11-23 11:47:12
 * @LastEditors: lan.h
 * @LastEditTime: 2021-12-01 10:08:58
 * @Description: 申报须知
-->
<template>
  <div class="vb100">
    <div class="declare-content">
      <div class="p_head" id="declare">
        <div class="p_title">
          <p>Declaration instructions</p>
          <h1>申报须知</h1>
        </div>
        <div class="p_links">
          <div class="links-item js-lower-anchor" @click="toA('#declare-relation')">
            <p class="links-name">联系我们</p>
          </div>
          <div class="links-item js-lower-anchor" @click="toA('#declare-fill')">
            <p class="links-name">资料下载</p>
          </div>
        </div>
      </div>
      <div class="declare" v-html="explain"></div>
      <div class="p_head p_head_declare" id="declare-relation">
        <div class="p_title">
          <p>Contact Us</p>
          <h1>联系我们</h1>
        </div>
      </div>  
      <ul class="declare-relation">
        <li v-for="item, index in contacts" :key="index">
          <div class="relation-left">
            <img :src="item.img_path | logo">
          </div>
          <div class="relation-right">
            <h1 class="over-p1">{{item.title}}</h1>
            <p>{{item.display_name}}</p>
            <p>{{item.tel}}</p>
            <p>{{item.email}}</p>
          </div>
        </li>
      </ul>
      <div class="p_head p_head_declare" id="declare-fill">
        <div class="p_title">
          <p>Relative infomation</p>
          <h1>资料下载</h1>
        </div>
      </div> 
      <ul class="declare-fill">
        <li v-for="item, index in file" :key="index">
          <div class="fill-left">
            <img src="~/img/main/fill.png" />
          </div>
          <div class="fill-center over-p3">{{item.name}}</div>
          <div class="fill-right">
            <a :href=" $store.state.img_req_url + item.file_path" target="_blank">下载</a>
          </div>
        </li>
      </ul> 
    </div>
  </div>
</template>
<script>
import { getDeclarationInstructions } from '@/service/main.js'
export default{
  data() {
    return {
      loading: false,
      explain: '',
      contacts: [],
      file: []
    }
  },
  created() {
    this.getDeclarationInstructions()
  },
  methods: {
    // 锚点跳转
    toA(id) {
      $("html,body").animate({ scrollTop: $(id).offset().top - 80 }, 500);
    },
    async getDeclarationInstructions() {
      let res = await getDeclarationInstructions({}, (error) => { this.$Message.error('请求错误') })
      if (res.status == 'success') {
        this.explain = res.explain.length > 0 ? res.explain[0].content : ''
        this.$set(this.$data, 'contacts', res.contacts)
        this.$set(this.$data, 'file', res.file)
      } 
    },
  }
}
</script>
<style lang="stylus" scoped>
@import '~css/main/list.stylus';
.declare-content
  width 1200px
  margin 0 auto
  .p_head
    width 100%
    margin 0 auto
    .p_links
      right 0
      .links-item
        height 30px
  .p_head_declare
    padding-top 60px
  .declare
    font-size 14px
    font-weight 500
    color #FFFFFF
    line-height 22px
    margin-top 45px
  .declare-relation
    display flex
    flex-wrap wrap
    margin-top 10px
    li
      margin-top 30px
      width 380px
      margin-right 30px
      background #1F2330
      border-radius 10px
      padding 30px 20px 30px 30px
      display flex
      .relation-left
        width 100px
        height 100px
        display flex
        justify-content space-between
        align-items center
        img 
          max-height 100%
          max-width 100%
      .relation-right
        margin-left 25px
        h1
          font-size 14px
          font-weight 800
          color #D9BB9E
          line-height 1
          margin-bottom 16px
        p 
          font-size 14px
          font-weight 500
          color #FFFFFF
          line-height 1
          margin-top 14px
    li:nth-child(3n)
      margin-right 0
  .declare-fill
    display flex
    flex-wrap wrap
    margin-top 10px
    margin-bottom 80px
    li
      margin-top 30px
      width 380px
      margin-right 30px
      background #1F2330
      border-radius 10px
      padding 20px
      display flex
      justify-content space-between
      align-items center
      .fill-left
        width 57px
        height 60px
        img 
          width 100%
      .fill-center
        font-size 14px
        font-weight 500
        color #FFFFFF
        line-height 22px
        width 185px
      .fill-right
        a
          display block
          width 60px
          background linear-gradient(90deg, #D9BB9E, #C78E66)
          border-radius 4px
          text-align center
          font-size 12px
          font-weight 500
          color #FFFFFF
          height 26px
          line-height 26px
          cursor pointer
    li:nth-child(3n)
      margin-right 0
</style>